<div class="main-motd">
  <h3 [innerHTML]="getUserMessageOfTheDay()"></h3>
</div>
<div class="grid download-area">
  <div class="col-12 download-txt">
    Veuillez cliquer sur le lien de téléchargement pour récupérer votre rapport :
  </div>
  <div class="col-12" (click)="download()">
    <i class="download-icon fa fa-cloud-download"></i>
  </div>
</div>






